import { Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';
import { useAuthStore } from '@/store/authStore';

const { Paragraph } = Typography;

export default function CurriculumHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const canManage = Boolean(
    user?.permissions?.includes('education.curriculum.manage') || user?.permissions?.includes('education.admin')
  );
  const cards = [
    {
      path: '/education/curriculum/units',
      title: t('curriculumUnits'),
      desc: t('curriculumUnitsIntro'),
    },
    ...(canManage
      ? [{
          path: '/education/curriculum/import',
          title: t('curriculumImportTitle'),
          desc: t('curriculumImportCardIntro'),
        }]
      : []),
    {
      path: '/education/academic',
      title: t('subjectCatalogue'),
      desc: t('curriculumSubjectsLinkHint'),
    },
  ];
  return (
    <EducationPageChrome title={t('curriculum')} description={t('curriculumIntro')}>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
